// Extras Docs
export const extrasDocs = [
  {
    id: 'extras_security_prices',
    label: 'Security Prices Download'
  },
  {
    id: 'security_price_comparison',
    label: 'Security Price Comparison'
  }
];
